<template>
  <ul
    class="margin-top-lg"
    :style="componentStyle"
  >
    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v7.solid.faParachuteBox"
        size="xl"
      />
      <span class="margin-left-lg">Hundreds of new icons with each update</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v7.solid.faWrench"
        size="xl"
      />
      <span class="margin-left-lg">The latest software updates and fixes</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v7.solid.faToolbox"
        size="xl"
      />
      <span class="margin-left-lg">Font Awesome Kits, Pro CDN, and other services</span>
    </li>

    <li :class="featureClass">
      <font-awesome-icon
        :icon="$v7.solid.faUserHeadset"
        size="xl"
      />
      <span class="margin-left-lg">
        Actual Human
        <span
          aria-label='No, "Actual Human" isn&apos;t really trademarked. But we will get you unstuck so you can get back to work.'
          data-balloon-pos="up"
          data-balloon-length="xlarge"
        >
          <font-awesome-icon
            :icon="$v7.regular.faTrademark"
            size="sm"
            transform="shrink-4 up-4 left-2"
          />
        </span>
        support from the Font Awesome Team
      </span>
    </li>

    <li
      v-if="isShowingBackerPerks"
      :class="featureClass"
    >
      <font-awesome-icon
        :icon="$v7.solid.faMoneyBillAlt"
        size="xl"
        style="color: var(--fa-dk-red)"
      />
      <span class="margin-left-lg">
        &hellip; and your super-special
        <strong>Backer 50% discount price</strong>
      </span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'SubscriptionFeatures',

    props: {
      isShowingBackerPerks: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      componentStyle() {
        return {
          ...{ '--list-style-type': 'none' },
          ...{ '--list-padding-left': '0' }
        }
      },
      featureClass() {
        return 'display-flex flex-row flex-items-start padding-vertical-sm'
      }
    }
  }
</script>
